import { Outlet, createRootRoute } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import { useTranslation } from 'react-i18next';

const LocalTimeIndicator = () => {
  const { t } = useTranslation();
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  if (timezone !== 'Asia/Seoul') {
    return (
      <div className="print:hidden fixed left-0 top-[95%] px-2 py-1 text-yellow-600 text-sm bg-yellow-200 rounded-md opacity-80 z-50 inset-x-0 max-w-max mx-auto">
        {t('root.timezoneWarning')}
      </div>
    );
  }
};

export const Route = createRootRoute({
  component: () => (
    <>
      <LocalTimeIndicator />
      <Outlet />
      <TanStackRouterDevtools />
    </>
  ),
});
